/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('NodeMemberInterceptor', [() => {
        return {
            response: function (response) {
                const
                    members = [];

                if (angular.isArray(response.resource)) {
                    angular.forEach(response.resource, function (entry) {
                        members.push(_decorateMember(entry));
                    });
                    return members;
                } else {
                    return _decorateMember(response.resource);
                }
            }
        };

        function _decorateMember(member) {
            member.isOwner = () => member.permission_for === 'owner';

            member.isGuest = () => member.permission_for === 'guest';

            member.isGroup = () => member.permission_for === 'share_group';

            member.isInherited = node => member['node']['uuid'] && member['node']['uuid'] !== node['uuid'];

            return member;
        }
    }
    ]);
 
 
